import React from "react";
import styles from "./HomeContact.module.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { GeoAltFill } from "react-bootstrap-icons";
import { EnvelopeFill } from "react-bootstrap-icons";
import { Linkedin } from "react-bootstrap-icons";
import Image from "../../../components/Image/Image";
import { NavLink } from "react-router-dom";

function HomeContact() {
  return (
    <>
      <div className={styles.contact_holder}>
        <Container>
          <Row>
            <Col md={12}>
              <div className={styles.info}>
                <div className={styles.box}>
                  <a
                    href="mailto:info@nearshoregm.com"
                    className={styles.links}
                  >
                    <EnvelopeFill
                      className={`${styles.icon} ${styles.email}`}
                    />
                    <span className={styles.name}>info@nearshoregm.com</span>
                  </a>
                </div>
                <div className={styles.box}>
                  <a href="" target="_blank" className={styles.links}>
                    <Linkedin className={`${styles.icon} ${styles.linkedin}`} />
                    <span className={styles.name}>Nearshore GM</span>
                  </a>
                </div>
                <div className={styles.box}>
                  <a
                    href="https://www.google.rs/maps/place/THINK+Innovative+Hub/@43.3060793,21.9488694,19.25z/data=!4m5!3m4!1s0x4755b1688ccffb43:0xa5abcdff89ef3d9b!8m2!3d43.3062937!4d21.9485077"
                    className={styles.links}
                    target="_blank"
                  >
                    <GeoAltFill className={styles.icon} />
                    <span className={`${styles.name} ${styles.address}`}>
                      Bulevar Svetog Cara Konstantina 80 <br /> 18000 Niš,
                      Serbia <br />
                      (Think Innovative Hub)
                    </span>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* <div className={styles.contact_link_holder}> */}
      {/* <Image
          url={triangle}
          alt="triangle"
          className={`page_graphic_image ${styles.graph_image_triangle}`}
        /> */}
      {/* <Image
          url={bckgImg}
          alt="background"
          className={`img-fluid ${styles.bckg_image}`}
        />
        <Container>
          <Row>
            <Col md={12}>
              <h3 className={styles.title}>
                Your partner for digital excellence.
              </h3>
              <p className={styles.text}>
                Work with our experts to achieve digital excellence through
                automation and accelerate your business with intelligent
                technology.
              </p>
              <NavLink to="/aboutus" className={`ns_button`}>
                Contact Us
              </NavLink>
            </Col>
          </Row>
        </Container> */}
      {/* </div> */}
    </>
  );
}

export default HomeContact;
